import request from '@/router/axios';

/**
 * 获取列表
 * @param {页数} page
 * @param {每页条数} limit
 * @param {查询参数} params
 */
export const getList = (page, limit, params) => {
    return request({
        url: '/api/exp/expsoftware/query',
        method: 'get',
        params: {
            ...params,
            page,
            limit,
        }
    })
}

/**
 * 批量删除
 * @param {Array} ids
 */
export const remove = ids => {
    return request({
        url: '/api/exp/expsoftware/deleteBatch',
        method: 'delete',
        data: ids
    })
}

/**
 * 获取对象
 * @param {ID} id
 */
export const getEntity = id => {
    return request({
        url: '/api/exp/expsoftware/' + id,
        method: 'get'
    })
}

/**
 * 添加操作
 * @param {对象} row
 */
export const add = row => {
    return request({
        url: '/api/exp/expsoftware',
        method: 'post',
        data: row
    })
}

/**
 * 编辑操作
 * @param {对象} row
 */
export const update = row => {
    return request({
        url: '/api/exp/expsoftware',
        method: 'put',
        data: row
    })
}

/**
 * 查重操作
 * @param {参数} params
 */
export const duplicateCheck = params => {
    return request('/api/exp/expsoftware/duplicateCheck', {
        method: 'get',
        params
    })
}

export const selectSoftList = () => {
    return request('/api/exp/expsoftware/selectSoftList', {
        method: 'get',
    })
}

export const updateApppram = (id, row) => {
    return request('/api/exp/expsoftware/updateapppram/' + id, {
        method: 'post',
        data: row
    })
}

/**
 * 获取UltraLink链接信息
 * @param {Object} data
 */
export const getLocalLink = (data = {}) => {
    return request('/api/exp/expsoftware/startinfo', {
        data
    }, 'post');
};